import styled from "@emotion/styled";
import {H1, H4} from "../../../../components/typography";
import Page from "../../../../components/Page";

export const Section = styled.div`
    width: 100%;
    margin: 20px 0;
    padding-top: 10px;
    word-break: keep-all;   

    ul {
        margin-top: 0.6em;
    }

    li {
        margin-bottom: 0.6em;

        span {

        }

        p {
            margin: 0;
            padding-left: 24px;
            text-indent: -8px;
        }
    }

    @media (hover: none) {
        br {
            display: none;
        }
    }
`;


export const ContentBox = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;
    min-height: 300px;
    position: relative;
`;

export const TitleContent = styled.div`
    width: 100%;
    min-height: 70px;
    background-color: #fff;
    border-top-right-radius: 16px;
    border-top-left-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const Ul = styled.ul`
    list-style: none;
    padding-left: 10px;
    color: #A2A2A2;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 1.7;
    margin: 0;
`;

export const TextContent = styled.div`
    letter-spacing: -0.5px;
    padding: 0 16px 20px 16px;
    height: 100%;
    background-color: ${({theme}) => theme.background[2]};
`;

export default function PersonalInfoCollect() {
    return (
        <ContentBox>
            <TitleContent><H1>개인정보 수집 및 이용 동의(필수)</H1></TitleContent>
            <TextContent>
                <Section>
                    <H4 mt={10} style={{color: "#4B4B4B"}}>한국정보인증㈜는 간편인증 및 전자서명을 위한 통합인증서비스 제공을 위하여 이용자의 개인정보를 아래와 같이 수집·이용 하고자 합니다.</H4>
                    <Ul>
                        <li>
                            <span>(1) 개인정보 이용 목적</span>
                            <p>- 이용자가 입력한 간편인증 및 전자서명에 필요한 정보를 전자서명인증사업자에 전달</p>
                        </li>
                        <li>
                            <span>(2) 수집 항목</span>
                            <p>- 이름, 휴대폰번호, 생년월일</p>
                        </li>
                        <li>
                            <span>(3) 개인정보의 보유기간 및 이용기간</span>
                            <p>- 이용기관에 간편인증 및 전자서명 정보 전달 후 즉시 파기</p>
                        </li>
                        <li>
                            <span>(4) 개인정보의 수집 및 이용거부</span>
                            <p>- 이용자는 개인정보 수집 및 이용에 대한 동의를 거부할 수 있습니다.<br/>단, 동의를 거부할 경우 통합인증서비스 이용이 제한됩니다.</p>
                        </li>
                    </Ul>
                </Section>
            </TextContent>
        </ContentBox>
    );
}
